// extracted by mini-css-extract-plugin
export default {"text":"normal_text__iHbFU"};